<template>
  <n-modal @cancel="emit('cancel')">
    <template v-slot:title
      ><p class="app-confirm-title">{{ title }}</p></template
    >
    <template v-slot:body><slot></slot></template>
    <template v-slot:buttons>
      <n-button-group>
        <n-button variant="primary" @click="emit('confirm')">Yes</n-button>
        <n-button variant="primary--outline" @click="emit('cancel')">Cancel</n-button>
      </n-button-group>
    </template>
  </n-modal>
</template>

<script lang="ts" setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
});

const emit = defineEmits<{
  (e: 'confirm'): void;
  (e: 'cancel'): void;
}>();
</script>

<style lang="scss" scoped>
.app-confirm-title {
  color: #363636;
  font-size: 1.5rem;
  line-height: 1;
}
</style>
